module.exports = __webpack_public_path__ + "img/footer_icon_top.8d63368f.svg";